import axios from "axios";

const LOGOUT_USER_URL = "https://dev.danzflo.com/api/v2/users/logout-user";

/**
 * Shared Danzflo logout. Bearer is the master token; the Event JWT
 * goes in the body only — other API calls keep using the Event token.
 */
export async function logoutPlatformUser({ masterToken, platformToken }) {
  return axios.post(
    LOGOUT_USER_URL,
    { token: platformToken },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${masterToken}`,
      },
    }
  );
}
